module.exports = __webpack_public_path__ + "sprite/buttons@2x.png";


//////////////////
// WEBPACK FOOTER
// ./sprite/buttons@2x.png
// module id = 124
// module chunks = 3